/**
 * Splide custom pagination.
 *
 * This will add pagination based on splides pagination.
 * We do this so that responsive paging settings will be respected.
 */

/**
 * Pagination function.
 * @param  {object} block          the block or container splide lives in.
 * @param  {object} splideInstance the splide instance created when instatiating splide.
 */
const splideCustomPagination = (block, splideInstance) => {
	const container = block.querySelector('.splide__slide-pagination');

	splideInstance.on('pagination:mounted', (data) => {
		let html = '';
		data.items.forEach((item, i) => {
			const active = i === 0 ? 'active' : '';
			html += `<div class="splide__slide-pagination-item"><i class="fa fa-circle ${active}" aria-hidden="true"></i></div>`;
		});
		container.innerHTML = html;
		const pagination = block.querySelectorAll('i');
		pagination.forEach((page, i) => {
			page.onclick = () => {
				splideInstance.go(`>${i}`);
			};
		});
	});

	const initPageNav = (newIndex) => {
		const pagintationItem = splideInstance.Components.Pagination.getAt(newIndex);
		const pagination = block.querySelectorAll('i');
		pagination.forEach((page) => {
			page.classList.remove('active');
		});
		pagination[pagintationItem.page].classList.add('active');
	};

	splideInstance.on('move', (newIndex) => {
		initPageNav(newIndex);
	});
};

export default splideCustomPagination;
